import axios from 'axios'
import { urlMap } from 'helpers/constants'

export const getLocation = params => {
    if (!params?.longitude) return
    return axios.get(`${urlMap.config}/geo-location`, { params })
}
